import { useReportStore } from '@store';
import { PatientsReport } from './PatientsReport.tsx';
import { TasksReport } from './TasksReport.tsx';
import { RecordsReport } from './RecordsReport.tsx';
import { UsersReport } from './UsersReport.tsx';

//It is assumed that the details modal has been completed at this point.
export const ReportWrapper = () => {
  const { report } = useReportStore();

  switch (report?.report_type) {
    case 'patients_report':
      return <PatientsReport />;
    case 'tasks_report':
      return <TasksReport />;
    case 'users_report':
      return <UsersReport />;
    case 'records_report':
      return <RecordsReport />;
    default:
      return <></>;
  }
};
